import { PERMISSIONS } from 'store/baseConfig';

export const AUTH_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.SUPER_ADMIN, PERMISSIONS.ADMIN, PERMISSIONS.USER]
};

export const SUPER_ADMIN_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.SUPER_ADMIN]
};

export const ADMIN_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.ADMIN]
};

export const USER_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.USER]
};

export const SUPER_ADMIN_AND_ADMIN_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.SUPER_ADMIN, PERMISSIONS.ADMIN]
};

export const SUPER_ADMIN_AND_USER_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.SUPER_ADMIN, PERMISSIONS.USER]
};

export const ADMIN_AND_USER_ACCESS = {
    protected: true,
    allowedRoles: [PERMISSIONS.ADMIN, PERMISSIONS.USER]
};






